export default __webpack_public_path__ + "static/media/bg-flow-0.35bbf6a1.png";